import React, { useState, useEffect } from 'react';
import { Card, Form } from '@deere/ux.uxframe-react'
import Table from '../../components/Table';
import { useDispatch, useSelector } from 'react-redux';
import { updateSurveyAnswers } from '../../redux/action/surveyAction';
import { SCBM_INDIRECT_SECCION_CODES, EMPTY_BODY, QUESTION_PROPRIETARY } from '../../utils/surveyLiterals'
import { findAnswerIndex, getTranslation } from '../../utils/utils';
import store from '../../redux/store'
import { useTranslation } from "react-i18next";
import "../../assets/css/Sections.css";
import {DebounceInput} from 'react-debounce-input';

export default function BusinessSegmentationPage({ survey }) {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [checkSection, setCheckSection] = useState("")
    const surveyResponse = useSelector(state => state.survey.surveyResponse);
    const [answers, setAnswers] = useState([])
    const section = survey.sections.find(e => e.code === SCBM_INDIRECT_SECCION_CODES.BS && e.active);
    const questions = section.questions.filter(qu => qu.active && qu.text !== QUESTION_PROPRIETARY).sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1);
    const menuOptions = questions[0].selections
    const propQuestion = section.questions.filter(qu => qu.active && qu.text === QUESTION_PROPRIETARY)[0];
    let tmpAns=useSelector(state => state.survey.surveyAnswers);

    const propComments = propQuestion ? findAnswerIndex(propQuestion.id, tmpAns) >= 0 ? tmpAns[findAnswerIndex(propQuestion.id, tmpAns)].answer : '' : '';
    
    useEffect(() => {
        setAnswers([...store.getState().survey.surveyAnswers]);
        if(propComments!==''){ setCheckSection('checked')}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [surveyResponse])

    if (!survey) return EMPTY_BODY;

    const updateAnswer = (e, questionId) => {
        dispatch(updateSurveyAnswers({ questionId: questionId, answer: e.target.value }));
        setAnswers([...store.getState().survey.surveyAnswers])
    }
    
    return (<>
        <Card>
            <Card.Body id={section ? section.description : ''}>
                <Card.Title className='pb-3 font-weight-bold'>
                    {getTranslation(section,'description')}
                </Card.Title>
                <Form.Row className="d-block mb-4">
                    <Form.Group>
                        <Form.Label className="uxf-label">{getTranslation(questions[0], 'text')}</Form.Label>
                        <Form.Control required={!checkSection} as="select" className="custom-select" 
                                    value={findAnswerIndex(questions[0].id, answers) >= 0 ? answers[findAnswerIndex(questions[0].id, answers)].answer : ''} 
                                    onChange={(e) => updateAnswer(e, questions[0].id)}
                                    name={`${getTranslation(section, 'description')}-${questions[0].id}`}>
                            
                            <option value=''>{t('lbl_dropdown_select')}</option>
                            {menuOptions ? menuOptions.sort((a, b) => (parseInt(a.value) > parseInt(b.value)) ? 1 : -1).map(opt => <option key={opt.id} value={opt.value}>{getTranslation(opt, 'text')}</option>) : null}
                        </Form.Control>
                        <div className="invalid-feedback">
                        {t('bs_required')}
                        </div>
                    </Form.Group>
                </Form.Row>
                <Form.Row className="d-block mb-4">
                    <Form.Group>
                        <Form.Label className="uxf-label mt-2">{getTranslation(questions[1], 'text')}</Form.Label>
                        <DebounceInput
                            element="textarea"
                            className="form-control"
                            onChange={(e) => updateAnswer(e,questions[1].id)}                            
                            placeholder={t('bs_textarea_placeholder')}
                            debounceTimeout={300}
                            value={findAnswerIndex(questions[1].id, answers) >= 0 ? answers[findAnswerIndex(questions[1].id, answers)].answer : null}
                            name={`${getTranslation(section, 'description')}-${questions[1].id}`}/>
                    </Form.Group>
                </Form.Row>
                <Table section={section} questions={questions} updateAnswer={updateAnswer} answers={answers} checkedProprietary={checkSection} isTotal={true}/>
            </Card.Body>
        </Card >
    </>)
}